import React from "react";
import { useTranslation } from "@edreamsodigeo/frontend-core";
import { Body, Box, CheckIcon, List, ListItem } from "@edreamsodigeo/prisma-design-system";
const ValuePropositionList = () => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(List.Base, null, /*#__PURE__*/React.createElement(ListItem, {
    icon: /*#__PURE__*/React.createElement(CheckIcon, {
      size: "medium",
      color: "neutral.90"
    })
  }, /*#__PURE__*/React.createElement(Box, {
    pb: "base",
    pl: "2"
  }, /*#__PURE__*/React.createElement(Body, {
    type: "base",
    color: "neutral.90"
  }, t("supportarea.mytripslogin.banner.text1")))), /*#__PURE__*/React.createElement(ListItem, {
    icon: /*#__PURE__*/React.createElement(CheckIcon, {
      size: "medium",
      color: "neutral.90"
    })
  }, /*#__PURE__*/React.createElement(Box, {
    pb: "base",
    pl: "2"
  }, /*#__PURE__*/React.createElement(Body, {
    type: "base",
    color: "neutral.90"
  }, t("supportarea.mytripslogin.banner.text2")))), /*#__PURE__*/React.createElement(ListItem, {
    icon: /*#__PURE__*/React.createElement(CheckIcon, {
      size: "medium",
      color: "positive.default"
    })
  }, /*#__PURE__*/React.createElement(Box, {
    pb: "base",
    pl: "2"
  }, /*#__PURE__*/React.createElement(Body, {
    type: "base",
    color: "green.50"
  }, t("supportarea.mytripslogin.banner.text3")))));
};
export default ValuePropositionList;